// extracted by mini-css-extract-plugin
export var card = "ContentWithSideCard-module--card--503bd";
export var container = "ContentWithSideCard-module--container--45811";
export var content = "ContentWithSideCard-module--content--f9356";
export var headerCentered = "ContentWithSideCard-module--header-centered--a3ce5";